import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import 'flatpickr/dist/flatpickr.css';
import CommonLoader, { LoaderStatus } from '../common/components/CommonLoader';
import SnapshotOverviewSection from './components/SnapshotOverviewSection';
import CustomerOverviewSection from './components/CustomerOverviewSection';
import { fetchAggregatedStatistics } from './DashboardActions';
import SaleOverviewSection from './components/SaleOverviewSection';
import FeesOverviewSection from './components/FeesOverviewSection';
import PurchaseOverviewSection from './components/PurchaseOverviewSection';

const breadcrumbs = [
  { id: 1, type: 'home' },
  { id: 2, type: 'span', text: 'Dashboard' },
];

function DashboardPage() {
  const dispatch = useDispatch();
  const [dataInitialized, setDataInitialized] = useState(false);

  useEffect(() => {
    dispatch(fetchAggregatedStatistics(() => setDataInitialized(true)));
  }, []);

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Statistics" />
      <CommonLoader status={dataInitialized ? LoaderStatus.SUCCESS : LoaderStatus.IN_PROGRESS}>
        <SnapshotOverviewSection />
        <CustomerOverviewSection />
        <SaleOverviewSection />
        <FeesOverviewSection />
        <PurchaseOverviewSection />
      </CommonLoader>
    </Container>
  );
}

export default DashboardPage;
